import { translate } from '../../../i18n/I18nProvider';

const validateMobileNumber = (number, options = {}) => {
  const { minLength = 8, maxLength = 8, digitsOnly = true } = options;

  const trimmedNumber = number.trim();

  if (digitsOnly && !/^[0-9]+$/.test(trimmedNumber)) {
    return {
      isValid: false,
      error: translate('VALIDATION.ONLY_DIGITS')
    };
  }

  if (trimmedNumber.length < minLength) {
    return {
      isValid: false,
      error: `${translate('VALIDATION.TOO_SHORT_NUMBER')} ${translate(
        'VALIDATION.DIGITS_LENGTH'
      )} ${minLength}`
    };
  }

  if (trimmedNumber.length > maxLength) {
    return {
      isValid: false,
      error: `${translate('VALIDATION.TOO_LONG_NUMBER')} ${translate(
        'VALIDATION.DIGITS_LENGTH'
      )} ${maxLength}`
    };
  }

  return {
    isValid: true,
    error: null
  };
};

export default validateMobileNumber;
